import { useEffect, useRef, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import styles from "./style.module.scss";
import { AtvMessageApi, AtvMessageDataType } from "@/api/AtvMessageApi";
import moment from "moment";
import { renderEDocumentStatusOffCanvasTrigger } from "@utils/ModelIndexUtils";
import { formatMoneyValue } from "@utils/Currency";
import { ProviderApi } from "@/api/ProviderApi";


const AtvMessageIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);
  const [providers, setProvider] = useState<Record<string, string>>({})

  useEffect(() => {
    loadProviders()
  }, []);

  const loadProviders = async () => {
    const providersNames = await ProviderApi.optionsList();
    setProvider(providersNames)
  }

  return (
    <PageContainer
      title="Lista de Mensajes ATV"
      backUrl="/user/dashboard-accounting"
    >
      <ModelIndex<AtvMessageDataType>
        ref={modelRef}
        fetchData={(...args) => AtvMessageApi.fetchAll(...args)}
        filterProps={[
          {
            key: "documentKey",
            filterType: "contains"
          },
          {
            key: "detalleMensaje",
            filterType: "contains"
          }
        ]}
        primaryProperties={[
          {
            key: "sequence",
            highlighted: true,
            className: styles.sequence
          },
          {
            key: (d) => providers[`${d.providerId}`] || "",
            alignment: "Start"
          },
        ]}
        primaryPropertiesSizing={
          [
            { sm: "4", xs: "12" },
            { sm: "8", xs: "12" }
          ]
        }
        secondaryProperties={[
          {
            key: (data) => {
              const date = moment(data.createdAt, "YYYY-MM-DD")
              return date.format("DD-MM-YYYY")
            },
            title: "Fecha",
          },
          {
            key: (data) => renderEDocumentStatusOffCanvasTrigger(data),
            title: "Estado ATV"
          },
          {
            key: (data) => {
              return formatMoneyValue(data.totalFactura, 1)
            },
            title: "Total",
            highlighted: true
          }
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "4", md: "2" },
            { sm: "4", md: "3" },
            { sm: "4", md: "2" }
          ]
        }
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default AtvMessageIndex;

